import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CONSIGNMENT_COMMAND = "CONSIGNMENT:REQUEST_CONSIGNMENT_COMMAND";
export const CONSIGNMENT_COMMAND = createSubmitRequestTypes("CONSIGNMENT:CONSIGNMENT_COMMAND");
export const requestConsignmentCommand = (consignmentAndActivities, report) => ({ type: REQUEST_CONSIGNMENT_COMMAND, consignmentAndActivities, report });
export const cancelConsignmentCommand = () => ({ type: CONSIGNMENT_COMMAND.CANCEL });
export const successConsignmentCommand = () => ({ type: CONSIGNMENT_COMMAND.SUCCESS });

export const REQUEST_CONSIGNMENT_DETAILS = "CONSIGNMENT:REQUEST_CONSIGNMENT_DETAILS";
export const CONSIGNMENT_DETAILS = createSubmitRequestTypes("CONSIGNMENT:CONSIGNMENT_DETAILS");
export const requestConsignmentDetails = (consignmentAndActivities) => ({ type: REQUEST_CONSIGNMENT_DETAILS, consignmentAndActivities });
export const cancelConsignmentDetails = () => ({ type: CONSIGNMENT_DETAILS.CANCEL });
export const successConsignmentDetails = () => ({ type: CONSIGNMENT_DETAILS.SUCCESS });